    import vue from 'vue'
    import SMSAlertService from "../../services/SMSAlertService";

    export default vue.extend({
    props:{        
        portfolio: Object,
        userInfo: Object,
    },
    methods: {        
        submit() {
            let phone = $('#sms-phone').val();                                          
            new SMSAlertService.AddMemeber(this.portfolio.id, phone);     
        }        
    }
});